<template>
  <div>
    <h1>Tape</h1>
    <p>Tape is on maintenance now.</p>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
}
</script>
